import Text from 'components/shared/Text'

import { SeniorConflictModalWrapper } from './styles'

import { FormattedMessage, useIntl } from 'react-intl'
import ModalInfo from 'components/shared/ModalInfo'
import { useAppSelector } from 'store/hooks'

interface SeniorConflictModalProps {
    onClick: () => void
    isLoading?: boolean
}

const SeniorConflictModal = ({
    onClick,
    isLoading,
}: SeniorConflictModalProps) => {
    const { formatMessage } = useIntl()
    const {
        seniorPackage: { isConflictModalOpened },
    } = useAppSelector((state) => state.ticket)

    return (
        <ModalInfo
            isOpened={isConflictModalOpened}
            variant="primary"
            buttonLabel={formatMessage({
                id: 'package.senior.conflict_modal_action_button',
                defaultMessage: 'Wróć do zamówienia',
            })}
            onButtonClick={() => onClick()}
            width={490}
            isLoading={isLoading}
            testIdPrefix="package-conflict-modal"
        >
            <SeniorConflictModalWrapper gap={16}>
                <Text variant="heading3" color="grayscale_900">
                    <FormattedMessage
                        id="package.senior.conflict_modal_title"
                        defaultMessage="Nie udało się dodać produktu do koszyka"
                    />
                </Text>
                <Text variant="body" color="grayscale_900">
                    <FormattedMessage
                        id="package.senior.conflict_modal_body_text"
                        defaultMessage="Aktualnie nie da się dodać Pakietu dla Seniora i noclegu w jednym zamówieniu. Zakup produkty oddzielnie, abyśmy mogli zrealizować zamówienie."
                    />
                </Text>
            </SeniorConflictModalWrapper>
        </ModalInfo>
    )
}

export default SeniorConflictModal
